module.exports = __webpack_public_path__ + "media/images/sp/plans/reason_01_before@2x-7c3625f8f68d11052c56628834ed7c10.webp";